module.exports = __webpack_public_path__ + "static/media/(V)_MG_4901_-_Pro-Natura_-_Moda_Feminina.425b79ec.jpg";